import type { StyleItemCustomEnum } from '@wix/thunderbolt-becky-root'
import { convertStyleProp } from './utils/convertStyleProps'
import type { BuilderStyle } from '@wix/document-services-types'
import type { PathScopedCustomEnums, Style } from '@wix/thunderbolt-becky-types'

export const stylePropsToCssVars = (
	style: BuilderStyle,
	pathScopedCustomEnums?: PathScopedCustomEnums,
	componentPath: string = 'root'
): Record<string, string | number> => {
	const { style: styleProps, spx } = style

	const cssVars = Object.entries(styleProps).reduce((acc: Record<string, string | number>, [propName, styleProp]) => {
		if (styleProp.type === 'CustomEnum') {
			Object.assign(
				acc,
				customEnumsToCssVar(
					(styleProp as StyleItemCustomEnum).value,
					propName,
					pathScopedCustomEnums,
					componentPath
				)
			)
			return acc
		}
		const converterVars = convertStyleProp(styleProp, propName, spx)
		Object.assign(acc, converterVars)
		return acc
	}, {})

	return cssVars
}

export const customEnumsToCssVar = (
	propValue: string,
	propName: string,
	pathScopedCustomEnums?: PathScopedCustomEnums,
	componentPath: string = 'root'
) => {
	return {
		[`--${propName}`]: propValue,
		...getAppliedStyles(pathScopedCustomEnums, propName, propValue, componentPath),
	}
}

const getAppliedStyles = (
	pathScopedCustomEnums: PathScopedCustomEnums | undefined,
	propName: string,
	propValue: string,
	componentPath: string
) => {
	return pathScopedCustomEnums?.[componentPath]?.[propName]?.[propValue] ?? {}
}

export const processBuilderStyle = (
	css: Style,
	pathScopedCustomEnums?: PathScopedCustomEnums,
	componentPath: string = 'root'
): Record<string, string | number> => {
	if (!css) {
		return {}
	}

	return Object.entries(css).reduce((acc: Record<string, string | number>, [key, value]) => {
		if (key === 'cssCustomProperties') {
			// Process each custom property to add -- prefix and applied styles
			Object.entries(value || {}).forEach(([propName, propValue]) => {
				Object.assign(
					acc,
					customEnumsToCssVar(propValue as string, propName, pathScopedCustomEnums, componentPath)
				)
			})
		} else {
			// Pass through CSS properties as-is
			Object.assign(acc, value || {})
		}
		return acc
	}, {})
}
